<script>
    import Error403 from './../components/Error403.svelte';
    import Loader from './../components/Loader.svelte';
    import {onMount} from 'svelte';

    import AlteryxService from "../services/alteryx.service";
    import { getFormat, formatValue } from "../helpers/format.helper";
    import AlteryxMetrics from "../components/AlteryxMetrics.svelte";
    import AlteryxCodes from "../components/AlteryxCodes.svelte";
    import AlteryxUsers from "../components/AlteryxUsers.svelte";
    import AlteryxUpload from "../components/AlteryxUpload.svelte";
    import AlteryxEmails from "../components/AlteryxEmails.svelte";

    export let params, errorMessage;
    let loading = false;

    let message = {
        show: false,
        type: "",
        text: ""
    }

    let sortBy = "kpis.id", order = true;
    let isAllowed; //Is allowed to access to this section


    onMount( async () => {
        await userAllowed();
    });

    let tab = "metrics";

    //Verify if user has permission to see this section
    async function userAllowed() {
        loading = true;
        try {
            const response = await AlteryxService.isAllowed();

            if (response && response.data && response.data.ok) {
                isAllowed = response.data.ok;
                if (!isAllowed) {
                    window.location = '/';
                }
            }
            loading = false;
        } catch (e) {
            console.log(e);
            errorMessage = e.message;
        } finally {
            loading = false;
        }
    }

    const tabList = [
        {
            value: "metrics",
            title: "Metrics",
            component: AlteryxMetrics
        },
        {
            value: "users",
            title: "Users",
            component: AlteryxUsers
        },
        {
            value: "codes",
            title: "Codes",
            component: AlteryxCodes
        },
        {
            value: "emails",
            title: "Emails",
            component: AlteryxEmails
        },
        {
            value: "upload",
            title: "Upload",
            component: AlteryxUpload
        }
    ]
</script>

<a id="download_csv" class="d-none" href="#" download="alteryx.csv"> </a>
{#if !isAllowed}
    <div class="row">
        <div class="col">
            {#if loading === true}
                <Loader fixed={true}></Loader>
            {:else}
                <Error403></Error403>
            {/if}
        </div>
    </div>
{:else}
    <div id="pageDiv">
        <main class="container alteryx-catalog">
            <div class="row">
                <div class="col">
                    <h3>Alteryx Catalog</h3>
                    <div class="pb-1">
                        <a class="navbar-brand" href="/dashboard"><small><i class="fa fa-angle-left"></i> Back to the Dashboard</small></a>
                    </div>
                    {#if loading === true}
                        <Loader fixed={true}></Loader>
                    {:else}
                        <ul class="nav nav-pills nav-fill pb-4">
                            {#each tabList as tabItem}
                                <li class="nav-item">
                                    <button class="general-tabs btn-block btn-default  {(tab === tabItem.value)?'active':''}" on:click={ () => tab = tabItem.value}>{tabItem.title}</button>
                                </li>
                            {/each}
                        </ul>
                        <svelte:component this={tabList.find(item => item.value === tab).component}></svelte:component>
                    {/if}
                </div>
            </div>
        </main>
    </div>
{/if}
